import React from "react";
import PhoneNav from "../PhoneNav";
import Footer2 from "../Footer2";
import "./About.css";

function About(props) {
  const {
    aboutUs,
    rectangle5,
    spanText1,
    spanText2,
    spanText3,
    spanText4,
    spanText5,
    spanText6,
    spanText7,
    spanText8,
    spanText9,
    spanText10,
    spanText11,
    famousBridalMakeupArtistInDelhi,
    sohniJunejaIsAnE,
    phoneNavProps,
    footer2Props,
  } = props;

  return (
    <div className="about screen">
      <PhoneNav image22={phoneNavProps.image22} className={phoneNavProps.className} />
      <div className="frame-48">
        <div className="about-us-1 poppins-medium-tundora-18px">{aboutUs}</div>
      </div>
      <div className="frame-282">
        <div className="frame-281">
          <img className="rectangle-5" src={rectangle5} />
          <p className="sohni-juneja-a-prod montserrat-semi-bold-tundora-10px">
            <span className="montserrat-semi-bold-tundora-10px">{spanText1}</span>
            <span className="montserrat-normal-tundora-10px">{spanText2}</span>
            <span className="montserrat-semi-bold-tundora-10px">{spanText3}</span>
            <span className="montserrat-normal-tundora-10px">{spanText4}</span>
          </p>
        </div>
        <p className="her-quest-for-adding montserrat-normal-tundora-10px">
          <span className="montserrat-normal-tundora-10px">{spanText5}</span>
          <span className="montserrat-medium-tundora-10px">{spanText6}</span>
          <span className="montserrat-normal-tundora-10px">{spanText7}</span>
          <span className="montserrat-medium-tundora-10px">{spanText8}</span>
          <span className="montserrat-normal-tundora-10px">{spanText9}</span>
          <span className="montserrat-medium-tundora-10px">{spanText10}</span>
          <span className="montserrat-normal-tundora-10px">{spanText11}</span>
        </p>
      </div>
      <div className="frame-285">
        <p className="her-immense-innovati">
          Her immense innovation when it comes fashion/catwalk makeup has also made her one of the most sought after
          with fashion photographers like Sarang Sena known for professionalism and versatility. Sohni did 54 shoots for
          a famous modeling agency in 5 days in Goa. Alongside she is also working as a Freelancer for renowned
          international magazines like Grazia, and other modeling agencies. Her constant innovation has also gave her
          opportunity to showcase her excellece in Styling and Makeup at fashion shows.
          <br />
          <br />
          Having a keen interest in sharing her knowledge about the same Sohni Juneja also takes regular sessions in
          various finishing schools across the country. Sohni Juneja is one on the best Bridal makeup artist in South
          Delhi and providing her professional services all over india.
          <br />
          <br />
          Sohni Juneja has been awarded The Garhwal post - Daughters of Uttarakhand award for Excellence in the art of
          makeup from his Excellency The Governor of Uttarakhand. She was also awarded Woman Achiever&#39;s Award 2018
          organised by Amar Ujaala.
        </p>
      </div>
      <div className="frame-284">
        <div className="famous-bridal-makeup-artist-in-delhi poppins-medium-tundora-20px">
          {famousBridalMakeupArtistInDelhi}
        </div>
      </div>
      <p className="sohni-juneja-is-an-e montserrat-normal-tundora-10px">{sohniJunejaIsAnE}</p>
      <Footer2 footer3Props={footer2Props.footer3Props} />
    </div>
  );
}

export default About;
